// src/index.ts
var PREFIX = "[PEXIP-ENGAGE]: ";
var logger = {
  debug(arg, ...args) {
    console.debug(PREFIX + arg, ...args);
  },
  info(arg, ...args) {
    console.info(PREFIX + arg, ...args);
  },
  warn(arg, ...args) {
    console.warn(PREFIX + arg, ...args);
  },
  error(arg, ...args) {
    console.error(PREFIX + arg, ...args);
  },
  log(arg, ...args) {
    console.log(PREFIX + arg, ...args);
  },
  group(arg, ...args) {
    console.group(PREFIX + arg, ...args);
  },
  groupEnd() {
    console.groupEnd();
  }
};
export {
  logger
};
